class CompareUtils {
  static cookieName = "pureveatheme:compare-products";
  /**
   *
   * @returns {array}
   */
  static getSelectedProducts() {
    const products = gspTheme.helper.getStorage(this.cookieName);
    return products || [];
  }
  static setSelectedProducts(products) {
    if (products.length > 0) {
      gspTheme.helper.setStorage(this.cookieName, products);
    } else {
      localStorage.removeItem(this.cookieName);
    }
  }
  static getProductsCount() {
    return this.getSelectedProducts().length;
  }
  static isProductInList(productId) {
    const products = this.getSelectedProducts();
    return products.find((product) => product.id === productId);
  }
  static addToList(productId, productUrl) {
    let products = this.getSelectedProducts();
    if (products.length < window.gspSetting.shop.compare_limit) {
      if (!products.some((product) => product.id === productId)) {
        products.push({ id: productId, url: productUrl });
      }
      this.setSelectedProducts(products);
      GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.compareAdded, { products, productId, productUrl });
      return true;
    } else {
      gspNotification.show({
        message: window.gspString.compareNotificationsLimit,
        type: "danger",
        method: "appendChild",
        icon: "circle_xmark",
        sticky: true,
        timeOut: 5e3
      });
      return false;
    }
  }
  static removeFromList(productId) {
    let products = this.getSelectedProducts();
    if (products) {
      products = products.filter((product) => product.id !== productId);
    }
    this.setSelectedProducts(products);
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.compareRemove, { products, productId });
  }
  static clearList() {
    const products = this.getSelectedProducts();
    if (products) {
      products.forEach((product) => {
        this.removeFromList(product.id);
      });
    }
  }
  static getTemplateUrl(productUrl, queryObj = {}) {
    let url = productUrl;
    const separator = productUrl.includes("?") ? "&" : "?";
    const params = new URLSearchParams();
    for (const key in queryObj) {
      if (Object.prototype.hasOwnProperty.call(queryObj, key)) {
        params.append(key, queryObj[key]);
      }
    }
    if (Array.from(params).length > 0) {
      url += `${separator}${params.toString()}`;
    }
    return url;
  }
  static getCompareBarItemTemplate(productUrl) {
    return this.getTemplateUrl(productUrl, {
      sections: "fetch__compare-item-preview"
    });
  }
  static getCompareMode() {
    return window.gspSetting.shop.compare_mode;
  }
  static isCompareModeCheckbox() {
    return this.getCompareMode() === "listing_checkbox";
  }
  static isCompareModeCard() {
    return this.getCompareMode() === "card_action";
  }
}
class CompareButtonElement extends HTMLElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
    this.addedClass = "active";
    this.productId = this.dataset.productId;
    this.productUrl = this.dataset.productUrl;
    this.titleCompare = this.dataset.titleCompare;
    this.content = this.dataset.context;
    this.titleAddedCompare = this.dataset.titleAddedCompare;
  }
  get buttonEl() {
    return this._buttonEl = this._buttonEl || this.querySelector("button");
  }
  itemRemoveUnsubscriber = void 0;
  itemAddUnsubscriber = void 0;
  connectedCallback() {
    this.init();
    this.buttonEl.addEventListener("click", this.onClickHandler);
    this.itemAddUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareAdded, this.onItemAdded.bind(this));
    this.itemRemoveUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareRemove, this.onItemRemoved.bind(this));
  }
  disconnectedCallback() {
    this.buttonEl.removeEventListener("click", this.onClickHandler);
    if (this.itemAddUnsubscriber) {
      this.itemAddUnsubscriber();
    }
    if (this.itemRemoveUnsubscriber) {
      this.itemRemoveUnsubscriber();
    }
  }
  init() {
    if (CompareUtils.isProductInList(this.productId)) {
      this.changeState(true);
    }
  }
  onClick(event) {
    event.preventDefault();
    gspTheme.helper.enableLoadingSpiner(this);
    if (CompareUtils.isProductInList(this.productId)) {
      CompareUtils.removeFromList(this.productId);
    } else {
      CompareUtils.addToList(this.productId, this.productUrl);
    }
    setTimeout(() => {
      gspTheme.helper.disableLoadingSpinner(this.buttonEl);
    }, 500);
  }
  onItemRemoved(event) {
    const { productId } = event;
    if (productId === this.productId) {
      this.changeState(false);
    }
  }
  onItemAdded(event) {
    const { productId } = event;
    if (productId === this.productId) {
      this.changeState(true);
    }
  }
  changeState(active) {
    if (this.content === "listing") {
      if (active) {
        this.buttonEl.classList.add(this.addedClass);
        this.updateTooltip(this.titleAddedCompare);
      } else {
        this.buttonEl.classList.remove(this.addedClass);
        this.updateTooltip(this.titleCompare);
      }
    } else {
      const label = this.querySelector(".btn-label");
      if (active) {
        this.buttonEl.classList.add(this.addedClass);
        label.textContent = this.titleAddedCompare;
      } else {
        this.buttonEl.classList.remove(this.addedClass);
        label.textContent = this.titleCompare;
      }
    }
  }
  updateTooltip(text) {
    this.buttonEl.setAttribute("data-bs-title", text);
    const tooltip = bootstrap.Tooltip.getInstance(this.buttonEl);
    if (tooltip) {
      tooltip.setContent({ ".tooltip-inner": text });
    }
  }
}
customElements.define("compare-button", CompareButtonElement);
class CompareRemoveElement extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.onClickHandler = this.onClick.bind(this);
  }
  get buttonEl() {
    return this._buttonEl = this._buttonEl || this.querySelector("button");
  }
  connectedCallback() {
    this.buttonEl.addEventListener("click", this.onClickHandler, {
      signal: this.abortController.signal
    });
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  onClick(event) {
    event.preventDefault();
    const { productId } = this.dataset;
    const { target } = event;
    CompareUtils.removeFromList(productId);
    const compareModal = target.closest("compare-modal");
    if (compareModal) {
      compareModal.updateProductsCount();
      if (CompareUtils.getProductsCount() < 2) {
        compareModal.hide();
      } else {
        const compareTable = target.closest(".compare-table");
        if (compareTable) {
          const cell = target.closest("td");
          const colIndex = cell.cellIndex;
          const rows = compareTable.querySelectorAll("tr");
          rows.forEach((row) => {
            const cellToRemove = row.cells[colIndex];
            if (cellToRemove) {
              cellToRemove.remove();
            }
          });
        }
      }
    }
  }
}
customElements.define("compare-remove", CompareRemoveElement);
class CompareSwitchElement extends HTMLElement {
  constructor() {
    super();
    this.cookieName = "pureveatheme:compare-is-active";
    this.checkboxEl = this.querySelector("input");
    this.onChangeHandler = this.onChange.bind(this);
    this.classes = {
      isActive: "compare-switch-active"
    };
  }
  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener("change", this.onChangeHandler);
  }
  disconnectedCallback() {
    this.checkboxEl.removeEventListener("change", this.onChangeHandler);
  }
  init() {
    const isActive = gspTheme.helper.getStorage(this.cookieName);
    if (isActive) {
      this.checkboxEl.checked = isActive;
      this.handleChange(isActive);
    }
  }
  onChange(event) {
    event.preventDefault();
    this.handleChange(this.checkboxEl.checked);
  }
  hide() {
    this.checkboxEl.checked = false;
    this.handleChange(false);
  }
  handleChange(isActive) {
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.compareToggle, { isActive });
    gspTheme.helper.setStorage(this.cookieName, isActive);
    if (CompareUtils.isCompareModeCheckbox()) {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    }
  }
}
customElements.define("compare-switch", CompareSwitchElement);
class CompareCheckboxElement extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.productId = this.dataset.productId;
    this.productUrl = this.dataset.productUrl;
    this.titleCompare = this.dataset.titleCompare;
    this.titleAddedCompare = this.dataset.titleAddedCompare;
    this.checkboxEl = this.querySelector("input");
    this.onChangeHandler = this.onChange.bind(this);
  }
  itemRemoveUnsubscriber = void 0;
  itemAddUnsubscriber = void 0;
  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener("change", this.onChangeHandler, {
      signal: this.abortController.signal
    });
    this.itemAddUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareAdded, this.onItemAdded.bind(this));
    this.itemRemoveUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareRemove, this.onItemRemoved.bind(this));
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this.itemAddUnsubscriber) {
      this.itemAddUnsubscriber();
    }
    if (this.itemRemoveUnsubscriber) {
      this.itemRemoveUnsubscriber();
    }
  }
  init() {
    const isAdded = CompareUtils.isProductInList(this.productId);
    this.checkboxEl.checked = isAdded;
    if (isAdded) {
      this.changeState(true);
    }
  }
  onChange(event) {
    event.preventDefault();
    if (this.checkboxEl.checked) {
      const isAdded = CompareUtils.addToList(this.productId, this.productUrl);
      if (!isAdded) {
        this.checkboxEl.checked = false;
      }
    } else {
      CompareUtils.removeFromList(this.productId);
    }
  }
  onItemRemoved(event) {
    const { productId } = event;
    if (productId === this.productId) {
      this.changeState(false);
      this.checkboxEl.checked = false;
    }
  }
  onItemAdded(event) {
    const { productId } = event;
    if (productId === this.productId) {
      this.changeState(true);
    }
  }
  changeState(active) {
    if (active) {
      this.updateTooltip(this.titleAddedCompare);
    } else {
      this.updateTooltip(this.titleCompare);
    }
  }
  updateTooltip(text) {
    this.setAttribute("data-bs-title", text);
    const tooltip = bootstrap.Tooltip.getInstance(this);
    if (tooltip) {
      tooltip.setContent({ ".tooltip-inner": text });
    }
  }
}
customElements.define("compare-checkbox", CompareCheckboxElement);
class CompareModalElement extends ModalComponent {
  constructor() {
    super();
    this.selectors = {
      table: ".compare-table",
      loading: ".gsp-loading-sections"
    };
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.listVariant = [];
    this.listProductVariant = [];
  }
  get sourceSelector() {
    return "#MainProduct-compare__rows";
  }
  get placeholderSelector() {
    return "#MainProduct-compare__placeholder";
  }
  onShowHandler() {
    this.renderCompareTable();
  }
  onHideHandler() {
    this.querySelectorAll(".compare-table > tbody > tr[data-compare-key]").forEach((row) => {
      const nonLabelCells = row.querySelectorAll("td:not(.td-label)");
      nonLabelCells.forEach((cell) => {
        cell.remove();
      });
    });
    this.querySelectorAll(".compare-table > tbody > tr[data-compare-variant-key]").forEach((row) => {
      row.remove();
    });
    this.elements.loading.classList.remove("hidden");
  }
  getSectionId() {
    let sectionId = GSP.ProductCompareSectionId || false;
    if (!sectionId) {
      const sectionEl = document.querySelector(".section-group-overlay-product-compare");
      if (sectionEl) {
        sectionId = gspTheme.helper.getSectionId(sectionEl);
      }
      GSP.ProductCompareSectionId = sectionId;
    }
    return sectionId;
  }
  async renderCompareTable() {
    const products = CompareUtils.getSelectedProducts();
    this.updateProductsCount();
    const tableRows = this.elements.table.querySelectorAll("tbody tr[data-compare-key]");
    let compareRows = await this.getCompareTableRows(products);
    let maxPlaceholderItems = 3;
    if (compareRows.length === 2) {
      maxPlaceholderItems = 2;
    }
    let numberPlaceholderItems = compareRows.length > 0 ? maxPlaceholderItems - compareRows.length : maxPlaceholderItems;
    if (Shopify.designMode) {
      if (numberPlaceholderItems > 0) {
        const placeholderRows = this.getCompareTablePlaceholderRows(numberPlaceholderItems);
        compareRows = compareRows.concat(placeholderRows);
        this.updateProductsCount(maxPlaceholderItems);
      }
    }
    compareRows.forEach((compareRow) => {
      tableRows.forEach((row) => {
        const compareKey = row.dataset.compareKey;
        const compareCol = compareRow.querySelector(`td[data-compare-key="${compareKey}"]`);
        if (compareCol) {
          row.appendChild(compareCol);
        }
      });
    });
    const table = this.elements.table.querySelector("tbody");
    this.listVariant.forEach((variant) => {
      let trEl = document.createElement("tr");
      trEl.setAttribute("data-compare-variant-key", variant);
      let tdHeadingEl = document.createElement("td");
      tdHeadingEl.setAttribute("class", "td-label text-heading");
      tdHeadingEl.textContent = variant;
      trEl.appendChild(tdHeadingEl);
      products.forEach((product) => {
        if (this.listProductVariant[product.id]) {
          if (this.listProductVariant[product.id][variant]) {
            trEl.appendChild(this.listProductVariant[product.id][variant]);
          } else {
            let tdEl = document.createElement("td");
            tdEl.textContent = "N/A";
            trEl.appendChild(tdEl);
          }
        }
      });
      if (Shopify.designMode) {
        if (numberPlaceholderItems > 0) {
          for (let i = 0; i < numberPlaceholderItems; i++) {
            let tdEl = document.createElement("td");
            tdEl.textContent = "N/A";
            trEl.appendChild(tdEl);
          }
        }
      }
      table.appendChild(trEl);
    });
    setTimeout(() => {
      this.elements.loading.classList.add("hidden");
    }, 300);
  }
  async getCompareTableRows(products) {
    const tmps = [];
    const sectionId = this.getSectionId();
    this.listVariant = [];
    this.listProductVariant = [];
    await Promise.all(
      products.map(async (product) => {
        const fetchUrl = CompareUtils.getTemplateUrl(product.url, {
          section_id: sectionId
        });
        await fetch(fetchUrl).then((response) => response.text()).then((responseText) => {
          const rowTemplate = new DOMParser().parseFromString(responseText, "text/html").querySelector(this.sourceSelector);
          const content = rowTemplate.content.cloneNode(true);
          tmps[product.id] = content;
          const variantsEl = content.querySelectorAll("td[data-compare-variant-key]");
          if (variantsEl.length > 0) {
            this.listProductVariant[product.id] = [];
            variantsEl.forEach((variantEl) => {
              const variant = variantEl.dataset.compareVariantKey;
              if (!this.listVariant.includes(variant)) {
                this.listVariant.push(variant);
              }
              this.listProductVariant[product.id][variant] = variantEl;
            });
          }
        });
      })
    );
    const returns = [];
    products.forEach((product) => returns.push(tmps[product.id]));
    return returns;
  }
  updateProductsCount(count) {
    this.style.setProperty("--number-items", count || CompareUtils.getProductsCount());
  }
  getCompareTablePlaceholderRows(count) {
    const rowTemplate = this.querySelector(this.placeholderSelector);
    const returns = [];
    for (let i = 0; i < count; i++) {
      returns.push(rowTemplate.content.cloneNode(true));
    }
    return returns;
  }
}
customElements.define("compare-modal", CompareModalElement);
class CompareOpenElement extends HTMLElement {
  constructor() {
    super();
    this.compareModal = document.querySelector("compare-modal");
    this.abortController = new AbortController();
    this.onClickHandler = this.onClick.bind(this);
  }
  itemAddUnsubscriber = void 0;
  itemRemoveUnsubscriber = void 0;
  connectedCallback() {
    const count = CompareUtils.getProductsCount();
    this.toggleCompareButton(count);
    this.buttonEl.addEventListener("click", this.onClickHandler, {
      signal: this.abortController.signal
    });
    this.itemAddUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareAdded, this.onItemUpdate.bind(this));
    this.itemRemoveUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareRemove, this.onItemUpdate.bind(this));
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this.itemAddUnsubscriber) {
      this.itemAddUnsubscriber();
    }
    if (this.itemRemoveUnsubscriber) {
      this.itemRemoveUnsubscriber();
    }
  }
  get buttonEl() {
    return this._buttonEl = this._buttonEl || this.querySelector("a") || this.querySelector("button");
  }
  onClick(event) {
    event.preventDefault();
    if (this.buttonEl.classList.contains("disable")) {
      return;
    }
    if (this.compareModal) {
      this.compareModal.show();
    }
  }
  toggleCompareButton(count) {
    this.buttonEl.disabled = !(count > 1);
    this.buttonEl.classList.toggle("disable", !(count > 1));
  }
  onItemUpdate(event) {
    const { products } = event;
    this.toggleCompareButton(products.length);
  }
}
customElements.define("compare-open", CompareOpenElement);
class CompareCountElement extends HTMLElement {
  constructor() {
    super();
  }
  itemAddUnsubscriber = void 0;
  itemRemoveUnsubscriber = void 0;
  connectedCallback() {
    this.init();
    this.itemAddUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareAdded, this.onItemUpdate.bind(this));
    this.itemRemoveUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareRemove, this.onItemUpdate.bind(this));
  }
  disconnectedCallback() {
    if (this.itemAddUnsubscriber) {
      this.itemAddUnsubscriber();
    }
    if (this.itemRemoveUnsubscriber) {
      this.itemRemoveUnsubscriber();
    }
  }
  init() {
    const count = CompareUtils.getProductsCount();
    this.updateCounters(count);
  }
  updateCounters(count) {
    this.innerText = count;
  }
  onItemUpdate(event) {
    const { products } = event;
    this.updateCounters(products.length);
  }
}
customElements.define("compare-count", CompareCountElement);
class ComparePreviewElement extends HTMLElement {
  itemAddUnsubscriber = void 0;
  itemRemoveUnsubscriber = void 0;
  compareToggleUnsubscriber = void 0;
  constructor() {
    super();
    this.abortController = new AbortController();
    this.selectors = {
      closeBtn: ".compare-preview__close",
      clearBtn: [".compare-preview__clear"],
      toggleList: ".compare-preview__toggle-list",
      list: ".compare-preview__items",
      counter: ".compare-preview__counter .count"
    };
    this.classes = {
      listVisible: "is-show-list",
      isActive: "is-product-comparing"
    };
  }
  connectedCallback() {
    this.elements = gspTheme.helper.queryDomNodes(this.selectors, this);
    this.itemRemoveUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareRemove, this.onItemRemoved.bind(this));
    this.itemAddUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareAdded, this.onItemAdded.bind(this));
    this.compareToggleUnsubscriber = GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.compareToggle, this.onCompareToggle.bind(this));
    this.elements.closeBtn.addEventListener("click", this.handleClose.bind(this), {
      signal: this.abortController.signal
    });
    this.elements.clearBtn.forEach((clearBtn) => {
      clearBtn.addEventListener("click", this.handleClear.bind(this), {
        signal: this.abortController.signal
      });
    });
    this.elements.toggleList.addEventListener("click", this.handleToggleList.bind(this), {
      signal: this.abortController.signal
    });
    document.addEventListener("matchMobile", this.setHeight.bind(this), {
      signal: this.abortController.signal
    });
    document.addEventListener("unmatchMobile", this.setHeight.bind(this), {
      signal: this.abortController.signal
    });
    this.setHeight();
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
    if (this.itemRemoveUnsubscriber) {
      this.itemRemoveUnsubscriber();
    }
    if (this.itemAddUnsubscriber) {
      this.itemAddUnsubscriber();
    }
    if (this.compareToggleUnsubscriber) {
      this.compareToggleUnsubscriber();
    }
  }
  init() {
    this.atLeastItemToShow = Math.min(5, GSP.config.settings.compareLimit);
    this.renderProducts();
  }
  async renderProducts() {
    const products = CompareUtils.getSelectedProducts();
    let output = "";
    const productsHtml = await this.getProducts(products);
    let count = productsHtml.length;
    productsHtml.forEach((htmlStr) => {
      if (htmlStr !== "") {
        output += htmlStr;
      }
    });
    this.removePlaceholders();
    this.elements.list.innerHTML = output;
    this.addPlaceholders(count);
    this.updateCounters(count);
  }
  async getProducts(products) {
    const tmps = [];
    await Promise.all(
      products.map(async (product) => {
        await fetch(CompareUtils.getCompareBarItemTemplate(product.url)).then((response) => response.json()).then((response) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(response["fetch__compare-item-preview"], "text/html");
          const itemHtml = doc.querySelector(".shopify-section");
          if (itemHtml && itemHtml.innerHTML.trim() !== "") {
            tmps[product.id] = itemHtml.innerHTML;
          }
        });
      })
    );
    return products.map((product) => tmps[product.id]).filter(Boolean);
  }
  removePlaceholders() {
    Array.from(this.elements.list.querySelectorAll("div")).forEach((item) => {
      if (item.classList.contains("compare-preview__item-placeholder")) {
        item.remove();
      }
    });
  }
  addPlaceholders(count) {
    const placeholderCount = this.atLeastItemToShow - count;
    for (let i = 0; i < placeholderCount; i++) {
      const placeholderItem = document.createElement("div");
      placeholderItem.classList.add("compare-preview__item-placeholder", "compare-preview__item");
      this.elements.list.appendChild(placeholderItem);
    }
  }
  onItemRemoved(event) {
    const { products, productId } = event;
    const itemToDelete = this.elements.list.querySelector(`.compare-preview__item[data-product-id="${productId}"]`);
    if (itemToDelete) {
      itemToDelete.remove();
    }
    this.updateCounters(products.length);
    this.removePlaceholders();
    this.addPlaceholders(products.length);
  }
  onItemAdded(event) {
    const { products, productId, productUrl } = event;
    this.appendBarItem(products, productId, productUrl);
    this.updateCounters(products.length);
    this.show();
  }
  onCompareToggle(event) {
    const { isActive } = event;
    if (isActive) {
      this.show();
    } else {
      this.hide();
    }
  }
  updateCounters(count) {
    if (this.elements.counter) {
      this.elements.counter.innerText = count;
    }
  }
  async appendBarItem(products, productId, productUrl) {
    this.removePlaceholders();
    this.elements.list.insertAdjacentHTML(
      "beforeend",
      `<div class="compare-preview__item-placeholder compare-preview__item" data-product-id="${productId}"></div>`
    );
    this.addPlaceholders(products.length);
    await fetch(CompareUtils.getCompareBarItemTemplate(productUrl)).then((response) => response.json()).then((response) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(response["fetch__compare-item-preview"], "text/html");
      const itemHtml = doc.querySelector(".shopify-section");
      const itemEl = this.elements.list.querySelector('[data-product-id="' + productId + '"]');
      if (itemEl) {
        itemEl.outerHTML = itemHtml.innerHTML;
      }
    });
  }
  handleClear() {
    CompareUtils.clearList();
  }
  handleClose() {
    this.hide();
    const compareSwitch = document.querySelector("compare-switch-dropdown");
    if (compareSwitch) {
      compareSwitch.hide();
    }
  }
  handleToggleList(event) {
    event.preventDefault();
    if (this.classList.contains(this.classes.listVisible)) {
      this.classList.remove(this.classes.listVisible);
    } else {
      this.classList.add(this.classes.listVisible);
    }
    this.setHeight();
  }
  setHeight() {
    requestAnimationFrame(() => {
      const offsetHeight = Math.round(this.offsetHeight);
      document.documentElement.style.setProperty("--compare-preview-height", `${offsetHeight}px`);
    });
  }
  show() {
    document.body.classList.add(this.classes.isActive);
    this.classList.add("show");
  }
  hide() {
    document.body.classList.remove(this.classes.isActive);
    this.classList.remove("show");
  }
  toggle() {
  }
}
customElements.define("compare-preview", ComparePreviewElement);
class CompareSwitchDropdownElement extends HTMLElement {
  constructor() {
    super();
    this.cookieName = "pureveatheme:compare-is-active";
    this.checkboxEl = this.querySelector("input");
    this.onChangeHandler = this.onChange.bind(this);
    this.abortController = new AbortController();
    this.classes = {
      isActive: "compare-switch-active"
    };
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  init() {
    if (!this.checkboxEl) {
      return;
    }
    const target = this.dataset.target;
    this.panel = document.querySelector(target);
    if (!this.panel) {
      return;
    }
    const isActive = gspTheme.helper.getStorage(this.cookieName);
    if (isActive) {
      this.checkboxEl.checked = isActive;
      this.handleChange(isActive);
    }
    this.checkboxEl.addEventListener("change", this.onChangeHandler, {
      signal: this.abortController.signal
    });
  }
  onChange(event) {
    event.preventDefault();
    this.handleChange(this.checkboxEl.checked);
  }
  hide() {
    this.checkboxEl.checked = false;
    this.handleChange(false);
  }
  handleChange(isActive) {
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.compareToggle, { isActive });
    gspTheme.helper.setStorage(this.cookieName, isActive);
    if (CompareUtils.isCompareModeCheckbox()) {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    }
  }
}
customElements.define("compare-switch-dropdown", CompareSwitchDropdownElement);
